// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"a1043200738d35ef0737","339":"bbc4062ce36974b61060"}[chunkId] + ".js";
};